import { curry, identity } from 'lodash/fp';
import { Func, Predicate } from '../types';
import { ifElse } from './ifElse';

interface CurriedWhen {
    <A extends unknown[], T>(condition: Predicate<A>, onTrue: Func<A, T>): Func<A, T | A[0]>;
    <A1 extends unknown[]>(condition: Predicate<A1>): <A2 extends A1, T>(onTrue: Func<A2, T>) => Func<A2, T | A2[0]>;
}

const uncurriedWhen = <A extends unknown[], T>(condition: Predicate<A>, onTrue: Func<A, T>) =>
    ifElse<A, T, A[0]>(condition, onTrue, identity);

export const when: CurriedWhen = curry(uncurriedWhen);
